
try {
    window.$ = window.jQuery = require('jquery');
    window.Swal = require("sweetalert2");
    window.select2 = require('select2');
} catch (e) {}

require('bootstrap');

require('owl.carousel/dist/owl.carousel.min')
require('lazyload')

window.addEventListener('closeModal', function (e) {
    $('#' + e.detail).modal('hide');
})
window.addEventListener('openModal', function (e) {
    $('#' + e.detail).modal('show');
})
window.addEventListener('preloadArtistPage', function (e) {
    $('#preloaderMoviesFilter').addClass('d-none')
})

window.addEventListener('sweetAlert', function (e) {
    Swal.fire({
        title: e.detail.title,
        icon: e.detail.icon,
        toast: true,
        showConfirmButton: false,
        position: 'bottom',
        timer: 4000,
        timerProgressBar: true,
    });
});

window.addEventListener('SliderCarousel', function (e) {
    $('#slider-carousel .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: true,
        margin: 0,
        nav: true,
        dots: true,
        autoplayTimeout: 3500,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            }
        }
    })
});

window.addEventListener('SliderCarouselMobile', function (e) {
    $('#slider-carousel .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: true,
        margin: 0,
        nav: true,
        dots: true,
        autoplayTimeout: 3500,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            }
        }
    })
});
window.addEventListener('FeatureCarousel', function (e) {
    $('.carousel-feature .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: false,
        margin: 0,
        nav: true,
        dots: false,
        autoplayTimeout: 3500,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.1,
                stagePadding: 0,
            },
            400: {
                items: 1.3
            },
            450: {
                items: 1.5
            },
            570: {
                items: 1.8
            },
            720: {
                items: 2.2
            }, 920: {
                items: 3.2
            }, 1280: {
                items: 4.2
            }

        }
    })
});
window.addEventListener('GenresCarousel', function (e) {
    $('.carousel-genres .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 5,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right ps-4'></i>",
            "<i class='fas fa-chevron-left pe-4'></i>"
        ],
        autoplay: false,
    })
    $('#preloadTabMovies').addClass('d-none')
    $('#preloadTabFilter').addClass('d-none')
    $('#preloaderMoviesFilter').addClass('d-none')

});

window.addEventListener('typeArtistsCarousel', function (e) {
    $('.carousel-type-artist .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 5,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right ps-4'></i>",
            "<i class='fas fa-chevron-left pe-4'></i>"
        ],
        autoplay: false,
    })
    $('#preloadTypeArtist').addClass('d-none')
    $('#preloaderArtist').addClass('d-none')
});

window.addEventListener('preloadGenrePage', function (e) {
    $('#preloaderMoviesGenre').addClass('d-none')
});

window.addEventListener('MoviesCarousel', function (e) {
    const owl = $('#owlCarouselMovies'); // Owl carousel in question
    $(owl).trigger('destroy.owl.carousel'); // Destroy carousel instance
    $(owl).html($(owl).find('.owl-stage-outer').html()).removeClass('owl-loaded'); // Destroy carousel instance part 2
    $(owl).owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 0,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
    }); // Initialize Owl carousel once again with same config options

});

$(document).ready(function () {
    $('.carousel-feature-loading .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: false,
        margin: 15,
        nav: true,
        dots: false,
        autoplayTimeout: 3500,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1.5,
                stagePadding: 5,
            },
            400: {
                items: 2.2
            },
            768: {
                items: 3.2
            }, 920: {
                items: 4.2
            },
            1600: {
                items: 5.2
            },
            1900: {
                items: 6.2
            }

        }
    });
    $('.proposed-carousel .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 0,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,

    });

    jQuery(document).on("click", ".btn-genre-tab-movie", function (e) {
        e.preventDefault();
        let btnGenre = $(this);
        let genre = $(this).attr('data-id');
        $('#preloadMovies').removeClass('d-none');
        $('#MoviesSection').addClass('d-none');

        if (btnGenre.hasClass('btn-dark')) {
            btnGenre.removeClass('btn-dark');
            btnGenre.addClass('btn-primary text-white');
            Livewire.emit('setGenre', genre);

        } else {
            btnGenre.addClass('btn-dark');
            btnGenre.removeClass('btn-primary text-white');
            Livewire.emit('unsetGenre', genre);
        }

    });

    jQuery(document).on("click", ".btn-type-artist-filter", function (e) {
        e.preventDefault();
        let btnGenre = $(this);
        let genre = $(this).attr('data-id');
        $('#preloaderArtist').removeClass('d-none');
        $('#artistsSectionList').addClass('d-none');

        if (btnGenre.hasClass('btn-dark')) {
            btnGenre.removeClass('btn-dark');
            btnGenre.addClass('btn-primary text-white');
            Livewire.emit('setTypeArtist', genre);

        } else {
            btnGenre.addClass('btn-dark');
            btnGenre.removeClass('btn-primary text-white');
            Livewire.emit('unsetTypeArtist', genre);
        }

    });

    jQuery(document).on("click", ".btn-tab-movies", function (e) {
        e.preventDefault();
        let btnTabs = $('.btn-tab-movies');
        let tab = $(this).attr('data-tab');

        if ($(this).hasClass('active'))
            return;

        $('#MoviesSection').addClass('d-none');
        $('.btn-genre-tab-movie').removeClass('btn-primary text-white btn-dark').addClass('btn-dark')
        btnTabs.removeClass('active');
        $(this).addClass('active')
        $('#preloadMovies').removeClass('d-none')
        Livewire.emit('setTab', tab);

    });


    jQuery(document).on("click", ".btn-filter-movies", function (e) {
        e.preventDefault();
        let btnTabs = $('.btn-filter-movies');
        let tab = $(this).attr('data-tab');

        if ($(this).hasClass('active'))
            return;

        btnTabs.removeClass('active');
        $(this).addClass('active')
        $('#preloaderMoviesFilter').removeClass('d-none')
        $('.btn-genre-filter').removeClass('btn-primary text-white btn-dark').addClass('btn-dark')


        Livewire.emit('setTabFilter', tab);

    });


    jQuery(document).on("click", ".btn-genre-filter", function (e) {
        e.preventDefault();
        let btnGenre = $(this);
        let genre = $(this).attr('data-id');
        $('#preloaderMoviesFilter').removeClass('d-none')
        $('#moviesSectionFilter').addClass('d-none');

        if (btnGenre.hasClass('btn-dark')) {
            btnGenre.removeClass('btn-dark');
            btnGenre.addClass('btn-primary text-white');
            Livewire.emit('setGenreFilter', genre);

        } else {
            btnGenre.addClass('btn-dark');
            btnGenre.removeClass('btn-primary text-white');
            Livewire.emit('unsetGenreFilter', genre);
        }


    });

    jQuery(document).on("click", ".btn-search-filter", function (e) {
        e.preventDefault();
        $('#preloaderMoviesFilter').removeClass('d-none');
        $('#moviesSectionFilter').addClass('d-none');
        $('#preloaderMoviesGenre').removeClass('d-none')

    });

    $("#sortFilterHomepage").on("input change", function () {
        $('#preloaderMoviesFilter').removeClass('d-none')
        $('#moviesSectionFilter').addClass('d-none');
        $('#preloaderMoviesGenre').removeClass('d-none')
    });

    $("#rangeMovieFilter").on("input change", function () {
        let value = $("#rangeMovieFilter").val();
        $('#preloaderMoviesFilter').removeClass('d-none')
        $('#preloaderMoviesGenre').removeClass('d-none')

        $('#moviesSectionFilter').addClass('d-none');
        document.getElementById('notActiveRangeMovieFilter').style.width = (100 - value * 10) + '%';
        document.getElementById('activeRangeMovieFilter').style.width = value * 10 + '%';
    });


    jQuery(document).on('click', '.btn-Bookmark-movie', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');

        Livewire.emit('bookmarkMovie', id);
        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fa-solid text-warning fa-bookmark ms-2 fa-lg"></i>نشان شده');
        } else {
            jQuery(this).html('<i class="far fa-bookmark ms-2 fa-lg"></i>نشان کردن');
        }
    })

    jQuery(document).on('click', '.btn-like-movie', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');

        Livewire.emit('wishlistMovie', id, 'like');

        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas text-success fa-thumbs-up fa-xl"></i>');
            jQuery('.btn-dislike-movie').html('<i class="far fa-thumbs-down fa-xl"></i>');
        } else {
            jQuery(this).html('<i class="far fa-thumbs-up fa-xl"></i>');
        }

    })

    jQuery(document).on('click', '.btn-dislike-movie', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');

        Livewire.emit('wishlistMovie', id, 'dislike');

        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas text-danger fa-thumbs-down fa-xl"></i>');
            jQuery('.btn-like-movie').html('<i class="far fa-thumbs-up fa-xl"></i>');
        } else {
            jQuery(this).html('<i class="far fa-thumbs-down fa-xl"></i>');
        }

    })


// Enable Bootstrap tooltips on page load
    $('[data-bs-toggle="tooltip"]').tooltip();

// Ensure Livewire updates re-instantiate tooltips
    if (typeof window.Livewire !== 'undefined') {
        window.Livewire.hook('message.processed', (message, component) => {
            $('[data-bs-toggle="tooltip"]').tooltip('dispose').tooltip();
        });
    }
    window.addEventListener('tooltip', function (e) {
        $('[data-bs-toggle="tooltip"]').tooltip()
    });


    jQuery(document).on('click', '.btn-edit-profile', function (e) {
        e.preventDefault();
        var btn = $('.btn-edit-profile');
        var profileBtn = $('.profile-btns');

        if (profileBtn.hasClass('profile-edit')) {
            profileBtn.removeClass('profile-edit');
            profileBtn.addClass('profile-btn');
            profileBtn.children('i').addClass('fa-user');
            profileBtn.children('i').removeClass('fa-pen');
            btn.html('ویرایش');
        } else {
            profileBtn.addClass('profile-edit');
            profileBtn.removeClass('profile-btn');
            profileBtn.children('i').removeClass('fa-user');
            profileBtn.children('i').addClass('fa-pen');
            btn.html('بازگشت');
        }
    });

    jQuery(document).on('click', '.profile-edit', function (e) {
        e.preventDefault();
        var id = $(this).attr('data-id');
        Livewire.emit('getModalIdProfile', id);
        $('#editProfileModal').modal('show');
    });
    jQuery(document).on('click', '.profile-btn', function (e) {
        e.preventDefault();
        var id = $(this).attr('data-id');
        Livewire.emit('setProfile', id);
    });
    jQuery(document).on('click', '.closeVerifyModal', function (e) {
        e.preventDefault();
        $('#verifyEditProfileModal').modal('hide');
    });
    jQuery(document).on('click', '.closeDeleteVerifyModal', function (e) {
        e.preventDefault();
        $('#verifyDeleteProfileModal').modal('hide');
    });
    jQuery(document).on('click', '.closeCreateVerifyModal', function (e) {
        e.preventDefault();
        $('#verifyCreateProfileModal').modal('hide');
    });
    jQuery(document).on('click', '.modalDeleteProfile', function (e) {
        e.preventDefault();
        $('#modalDeleteProfile').modal('hide');
    });

    jQuery(document).on('click', '.profile-add', function (e) {
        e.preventDefault();
        Livewire.emit('getModalIdProfile');
        $('#editProfileModal').modal('show');
    });
    jQuery(document).on('click', '.modalDeleteProfile', function (e) {
        e.preventDefault();
        $('#modalDeleteProfile').modal('show');
    });

    jQuery(document).on('click', '.btn-mobile-menu', function (e) {
        $('#preloaderMobile').removeClass('d-none');
    });


    $('#inputSearchHeader').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMember(value), 500)
    });

    let timeoutID = null;

    function findMember(str) {

        $('#spinnerLoadingSearch').removeClass('d-none');
        $('#loadingSearch').removeClass('d-none');
        Livewire.emitTo('site.sections.search-modal', 'changeQ', str);
    }


    jQuery(document).on("click", ".btn-comment-like-movie", function (e) {
        e.preventDefault();
        let likeMove = jQuery(this).closest('.btn-comment-like-movie');
        let dataId = likeMove.attr('data-id');
        let count = likeMove.attr('data-count');
        Livewire.emit('commentLikeMovie', dataId, 'like');
        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-up ms-1 fa-lg"></i> ' + ++count);
            let dislike = jQuery('#btn-dislike-' + dataId).attr('data-count');

            if (jQuery('#btn-dislike-' + dataId).children('i').get(0).classList.contains('fas')) {
                --dislike;
                console.log(dislike);
                jQuery('#btn-dislike-' + dataId).attr('data-count', dislike);
            }

            jQuery('#btn-dislike-' + dataId).html('<i class="far ms-1 fa-thumbs-down fa-lg"></i> ' + dislike);
            likeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + --count);
            likeMove.attr('data-count', count);
        }
    });

    jQuery(document).on("click", ".btn-comment-dislike-movie", function (e) {
        e.preventDefault();
        let dislikeMove = jQuery(this).closest('.btn-comment-dislike-movie');
        let dataId = dislikeMove.attr('data-id');
        let count = dislikeMove.attr('data-count');
        Livewire.emit('commentLikeMovie', dataId, 'dislike');

        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-down ms-1 fa-lg"></i> ' + ++count);
            var like = jQuery('#btn-like-' + dataId).attr('data-count');

            if (jQuery('#btn-like-' + dataId).children('i').get(0).classList.contains('fas')) {
                --like;
                console.log(like);
                jQuery('#btn-like-' + dataId).attr('data-count', like);
            }

            jQuery('#btn-like-' + dataId).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + like);
            dislikeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-down ms-1 fa-lg"></i> ' + --count);
            dislikeMove.attr('data-count', count);
        }
    });

    $('img').lazyload();

})
;
